import { useState, useEffect, useRef, useDeferredValue } from 'react';
import { useDebounce } from './useDebounce';
/**
 * Возвращает последнее установленное значение value.
 * Смена значения value происходит, только если за указанный промежуток времени хуку
 * не было передано другое значение.
 *
 * @param value Значение
 * @param waitMs Время ожидания установки нового значения
 * @typeParam Value Тип значения
 * @returns Последнее установленное значение
 */
export function useDebouncedValue(value, waitMs) {
    const initialRef = useRef(true);
    const [storedValue, setStoredValue] = useState(value);
    const setStoredValueDebounced = useDebounce(setStoredValue, waitMs);
    const deferredValue = useDeferredValue(storedValue);
    useEffect(() => {
        if (initialRef.current) {
            initialRef.current = false;
            return;
        }
        setStoredValueDebounced(value);
    }, [setStoredValueDebounced, value]);
    return deferredValue;
}
